var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hot-panel-text"},[_c('section-title',{attrs:{"title":_vm.title}}),_c('div',_vm._l((_vm.list),function(item,idx){return _c('p',{key:idx,staticClass:"text"},[_vm._v(_vm._s(item.name))])}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }